/**
 * Product Card Component
 * --------------------------------------------------------------------------------
 * @summary quickadd logic
 */
export class RelatedProducts extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            addToCart: "[js-add-to-cart]",
            addAllToCart: "[js-add-all-to-cart]",
            relatedInputs: "[js-related-input]",
        };
    }

    connectedCallback() {
        this.cart = document.querySelector("cart-drawer");
        this.cartDrawer = document.querySelector("#CartDrawer");
        this.addToCart = this.querySelectorAll(this._selectors.addToCart);
        this.addAllToCart = this.querySelector(this._selectors.addAllToCart);
        this.relatedInputs = this.querySelectorAll(
            this._selectors.relatedInputs,
        );

        this._setupListeners();
    }

    _setupListeners() {
        if (this.addToCart) {
            this.addToCart.forEach((button) => {
                button.addEventListener("click", this._addToCart);
            });
        }
        if (this.addAllToCart && this.relatedInputs) {
            this.addAllToCart.addEventListener("click", this._addAllToCart);
        }
    }

    _cartAdd(data) {
        // Fetch post add to cart
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((response) => {
                if (document.querySelector("cart-items")) {
                    document.querySelector("cart-items").onCartUpdate();
                }
                this.cart.renderContents(response);
                if (this.cartDrawer.getAttribute("aria-hidden") === "true") {
                    this.cartDrawer.open();
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    _addToCart = (evt) => {
        evt.preventDefault();
        const target = evt.currentTarget;
        const data = {
            items: [{ id: target.dataset.variantId, quantity: 1 }],
            sections: this.cart
                .getSectionsToRender()
                .map((section) => section.id),
        };
        this._cartAdd(data);
    };

    _addAllToCart = (evt) => {
        evt.preventDefault();
        const data = {
            items: [],
            sections: this.cart
                .getSectionsToRender()
                .map((section) => section.id),
        };
        this.relatedInputs.forEach((input) => {
            if (input.checked) {
                data.items.push({ id: input.value, quantity: 1 });
            }
        });
        this._cartAdd(data);
    };
}
